const KIRCHE_NORESULT = `
<div class="row mt-4 mb-4">
  <div class="col-12">
    <div class="box br-10 bg-default-gray">
      <div class="box-middle text-center p-4">
        <div class="d-flex justify-content-center mb-3">
          <div class="bg-white rounded-circle d-flex align-items-center justify-content-center" style="width:72px;height:72px;">
            <div class="icon-smiley-sleepy fs-1"></div>
          </div>
        </div>
        <h5 class="fw-bold">Hier gibt es derzeit noch keine Inhalte.</h5>
        <p class="fs-small text-black-50 mt-2">Wir arbeiten daran, dass sich dies bald ändert.<br>Bitte versuche es später erneut.</p>
        <a href="/mehr" class="btn btn-primary d-block mt-3">Zurück</a>
      </div>
    </div>
  </div>
</div>`;

function escapeKircheText(value) {
  return $('<div>').text(value || '').html();
}

function buildKircheAccordion(topics) {
  const items = topics.map(function(box, index) {
    const articles = (box.articles || []).map(function(article) {
      return `
        <div class="row pt-2 pb-2">
          <div class="col-12">
            <h6 class="fw-bold">${escapeKircheText(article.title)}</h6>
            <p class="fs-small">${escapeKircheText(article.content)}</p>
          </div>
        </div>
        <hr class="mt-0 border">`;
    }).join('');

    return `
      <li class="accordion-item">
        <h2 class="accordion-header" id="kirche-heading-${index}">
          <button class="accordion-button collapsed" type="button"
                  data-bs-toggle="collapse" data-bs-target="#kirche-collapse-${index}"
                  aria-expanded="false" aria-controls="kirche-collapse-${index}">
            <span class="mb-0 ps-2 pe-2">${escapeKircheText(box.title)}</span>
          </button>
        </h2>
        <div id="kirche-collapse-${index}" class="accordion-collapse collapse"
             aria-labelledby="kirche-heading-${index}" data-bs-parent="#kirche-accordion">
          <div class="accordion-body">
            ${articles || '<p class="fs-small text-black-50">Keine Artikel vorhanden.</p>'}
          </div>
        </div>
      </li>`;
  }).join('');

  return `<ul class="list-unstyled accordion" id="kirche-accordion">${items}</ul>`;
}

$(document).on('turbo:load', async function() {
  if ($('#kirche-content').length === 0) { return; }

  const districtId = $('#kirche-content').data('district-id');

  try {
    const response = await fetch(`/orte/${districtId}/church_topics`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) {
      $('#kirche-content').html(KIRCHE_NORESULT);
      return;
    }

    const topics = await response.json();

    if (!topics || topics.length === 0) {
      $('#kirche-content').html(KIRCHE_NORESULT);
      return;
    }

    $('#kirche-content').html(`<div class="row mt-3"><div class="col-12">${buildKircheAccordion(topics)}</div></div>`);
  } catch (e) {
    $('#kirche-content').html(KIRCHE_NORESULT);
  }
});
